import { useEffect } from "react";
import useWatchlistQuoteStore, {
  syncSubscriptions,
} from "../../../store/watchlistQuoteStore";

/**
 * Thin hook: syncs subscriptions when symbols change, reads rows from store.
 * No cleanup on unmount — data and subscriptions survive layout reorganization.
 */
export const useWatchlistData = (symbols) => {
  useEffect(() => {
    syncSubscriptions(symbols);
  }, [symbols.join(",")]); // eslint-disable-line react-hooks/exhaustive-deps

  const rows = useWatchlistQuoteStore((s) => s.rows);
  return { rows };
};
